import { Select } from "components/ui/select";
import { useLocalStorage } from "hooks/use-local-storage";
import { useTranslation } from "react-i18next";

export const LanguageSelection = () => {
  const { i18n } = useTranslation();
  const [, setLanguage] = useLocalStorage("language", "en");

  const updateLanguage = (option: { text: string; value: any }) => {
    setLanguage(option.value);
    i18n.changeLanguage(option.value);
  };

  return (
    <Select
      options={[
        { text: "English", value: "en" },
        { text: "Italian", value: "it" },
        { text: "Icelandic", value: "is" },
      ]}
      selected={i18n.language}
      setSelected={updateLanguage}
    />
  );
};
